<template>
  <v-container fill-height style="min-width: 100%;" justify-content-center class="pa-0 login-background" :gradient="gradient" dark>
    <v-layout column align-center style="max-height: 550px;">
      <v-flex 
        xs12 
        sm8 
        md6 
        lg5 
        xl4 
        offset-sm4 
        class="login-panel margin-auto py-3 px-7" 
        :class="{ 'fixed-width': $vuetify.breakpoint.smAndUp && step !== steps.CHECK_YOUR_EMAIL}"
      >
        <div style="display: flex; justify-content: center;" id="logo" class="pb-6">
          <logo 
            v-if="(!existNextUrl && step === steps.ENTER_EMAIL) ||
              step === steps.SELECT_LOGIN_TYPE || 
              step === steps.ENTER_PASSWORD
            " 
            alwaysExtended 
            :theme="theme" 
            class="login-logo my-3" 
            :height="50" 
          />
          <lock-icon class="mt-10" :class="{'invert-color': theme === 'ligth' }" v-if="step === steps.ENTER_EMAIL && existNextUrl" />
          <mail-icon class="mt-10" :class="{'invert-color': theme === 'ligth' }" v-if="step === steps.CHECK_YOUR_EMAIL" />
        </div>
        <v-layout
          v-if="step === steps.ENTER_PASSWORD || step === steps.SELECT_LOGIN_TYPE"
          row
          justify-center
          class="pa-2 mb-2 email-text"
          :class="theme === 'dark' ? 'white--text' : 'black--text'"
        >
          <v-icon
            class="mr-2"
            :class="theme === 'dark' ? 'white--text' : 'black--text'"
          >
            mdi-email
          </v-icon>
          <span>{{credentials.email}}</span>
        </v-layout>
        <div v-if="titleLogin" class="pa-2 text-center mt-4" :class="theme === 'dark' ? 'white--text' : 'black--text'">
          <p v-if="step === steps.ENTER_EMAIL || step === steps.ENTER_PASSWORD || step === steps.CHECK_YOUR_EMAIL" class="login-title">{{ titleLogin }}</p>
          <p v-if="step === steps.ENTER_EMAIL || step === steps.CHECK_YOUR_EMAIL" class="text-login mt-3">{{ text }}</p>
        </div>
        <div class="pa-2"></div>
        <v-form v-if="step === steps.ENTER_EMAIL" ref="email" autocomplete="on">
          <v-text-field 
            type="email"
            name="email"
            :readonly="state.loading"
            validate-on-blur
            :rules="[rules.required, rules.validEmail]"
            :error="loginError"
            v-model="credentials.email"
            prepend-inner-icon="email"
            :placeholder="!credentials.email ? $t('fields.email') : ''"
            autofocus
            solo
            flat
            v-on:keydown.enter.prevent="nextStep(steps.SELECT_LOGIN_TYPE)"
          />
        </v-form>
        <v-form v-if="step === steps.ENTER_PASSWORD" ref="password" autocomplete="on">
          <v-text-field 
            :rules="[rules.required]"
            :readonly="state.loading"
            v-on:keydown.enter.prevent="signIn()"
            :error="loginError"
            v-model="credentials.password"
            type="password"
            name="password"
            prepend-inner-icon="vpn_key"
            :placeholder="$t('fields.password')"
            autofocus
            solo
            flat
          />
        </v-form>
        <!-- BUTTONS -->
        <v-layout v-if="step === steps.ENTER_EMAIL">
          <v-btn
            v-if="existNextUrl"
            :color="theme === 'dark' ? 'white' : 'primary'"
            :outlined="theme === 'dark'"
            dark 
            large
            style="width: 48%"
            @click="back"
          >
            {{ $t('actions.go_back' )}}
          </v-btn>
          <v-spacer />
          <v-btn
            :dark="theme === 'dark'"
            large
            :color="theme === 'dark' ? 'white' : 'primary'"
            :outlined="theme === 'dark'"
            :block="!existNextUrl"
            :style="existNextUrl ? 'width: 48%' : ''"
            @click="nextStep(steps.SELECT_LOGIN_TYPE)"
          >
             {{ $t('actions.continue' )}}
          </v-btn>
        </v-layout>

        <div
          v-if="step === steps.ENTER_EMAIL && !!selfRegistrationBaseUrl"
          class="my-9 text-center"
        >
          <span>
            {{ $t('login.no_account') }}

            <a
              class="font-weight-bold"
              :href="selfRegistrationBaseUrl"
              v-text="$t('login.create_one')"
            />
          </span>
        </div>

        <v-btn
          v-if="step === steps.ENTER_PASSWORD"  
          id="login-btn" 
          :loading="loginError === false" 
          :color="theme === 'dark' ? 'white' : 'primary'"
          :outlined="theme === 'dark'"
          block
          dark
          large
          @click="signIn()" 
          class="mb-3"
        >
          {{$t('actions.sign_in')}}
        </v-btn>
        <template v-if="step === steps.SELECT_LOGIN_TYPE">
          <v-btn  
            id="login-btn"
            large 
            block
            dark
            :loading="loginError === false" 
            :color="theme === 'dark' ? 'white' : 'primary'"
            :outlined="theme === 'dark'"
            @click="step = steps.ENTER_PASSWORD"
            ref="loginWithPassword"
          >
            {{$t('login.log_in_with_password')}}
          </v-btn>
          <v-layout row class="mx-0 my-5" justify-center align-center>
            <v-divider
              :color="theme === 'dark' ? 'white' : 'black'">
            </v-divider>
            <span
              class="mx-3" 
              :class="theme === 'dark' ? 'white--text' : 'black--text'"
            >
              {{$t('login.or')}}
            </span>
            <v-divider
              :color="theme === 'dark' ? 'white' : 'black'">
            </v-divider>
          </v-layout>
          <v-btn
            large 
            block
            dark
            :loading="loadingLink" 
            :color="theme === 'dark' ? 'white' : 'primary'"
            :outlined="theme === 'dark'"
            @click="sendAccessLink()"
          >
            {{$t('login.send_access_link')}}
          </v-btn>
          <p
            :class="theme === 'dark' ? 'white--text' : 'black--text'" 
            class="text-center mt-4 explanatory-text"
          >
            {{$t('login.info_access_link')}}
          </p>
        </template>
        <p
          v-if="step === steps.CHECK_YOUR_EMAIL" 
          class="caption text-center font-weight-medium"
          :class="theme === 'dark' ? 'white--text' : 'black--text'"
        >
          {{$t('login.dont_send_email')}}
          <b class="clickable underline" @click="step = steps.ENTER_EMAIL">
            {{$t('login.try_diferent_email')}}
          </b>
        </p>
      </v-flex>
      <v-flex
        id="logo"
        v-if="existNextUrl && step === steps.ENTER_EMAIL"
        style="display: flex; justify-content: center; align-items: center; max-height: 300px;"
        class="mb-2 flex-item"
      >
        <logo alwaysExtended :theme="theme" class="login-logo my-3" :height="50" />
      </v-flex>
      <v-flex
        v-if="step === steps.SELECT_LOGIN_TYPE || step === steps.ENTER_PASSWORD"
        style="display: flex; justify-content: center; align-items: center;"
        class="mb-2 flex-item"
      >
        <v-btn
          tabindex="10"
          @click="step -= 1"
          text
          class="no-background"
          :dark="theme === 'dark'"
        >
          {{ $t('actions.go_back') }}
        </v-btn>
      </v-flex>
      <v-flex
        v-if="step === steps.CHECK_YOUR_EMAIL"
        style="display: flex; justify-content: center; align-items: center;"
        class="mb-2 flex-item"
      >
        <v-btn
          tabindex="10"
          @click="reset()"
          text
          class="no-background"
          :dark="theme === 'dark'"
        >
          {{ $t('actions.close') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { themeByGradient } from '@/lib/helpers/ColorUtils'
import { required, validEmail } from '@/lib/helpers/ValidationRules'
import routingMixins from '@/mixins/Routing'
import moment from 'moment'
const steps = {
  'ENTER_EMAIL': 1,
  'SELECT_LOGIN_TYPE': 2,
  'ENTER_PASSWORD': 3,
  'CHECK_YOUR_EMAIL': 4,
}
export default {
  data () {
    return {
      moment,
      steps,
      step: steps.ENTER_EMAIL,
      title: process.env.VUE_APP_TITLE,
      valid: true,
      credentials: {
        email: null,
        password: null,
      },
      loginError: null,
      gradient: 'to top right, rgba(28,49,58, .8), rgba(69,90,100, .8)',
      rules: {
        required,
        validEmail,
      },
      theme: themeByGradient(this.$vuetify.theme.themes.light.accent.darken1, this.$vuetify.theme.themes.light.accent.lighten1),
      loadingLink: false,
    }
  },
  computed: {
    ...mapState(['state', 'service']),
    selfRegistrationBaseUrl () {
      return this.service.configuration && this.service.configuration.selfRegistrationBaseUrl ? this.service.configuration.selfRegistrationBaseUrl : null
    },
    existNextUrl () {
      return this.$route.query['next-url'] ? true : false
    },
    titleLogin () {
      if (this.existNextUrl && this.step === steps.ENTER_EMAIL) return this.$t('login.authentication')
      if (!this.existNextUrl && this.step === steps.ENTER_EMAIL) return this.$t('login.welcome')
      if (this.step === steps.ENTER_PASSWORD) return this.$t('login.enter_to_password')
      if (this.step === steps.CHECK_YOUR_EMAIL) return this.$t('login.check_your_email')
    },
    text () {
      if (this.existNextUrl && this.step === steps.ENTER_EMAIL) return this.$t('login.access_route')
      if (!this.existNextUrl && this.step === steps.ENTER_EMAIL) return this.$t('login.instructions')
      if (this.step === steps.CHECK_YOUR_EMAIL) return this.$t('login.success_access_link')
    },
  },
  components: {
    Logo: () => import('@/components/app-components/Logo.vue'),
    LockIcon: () => import('@/../public/lock-icon.svg'),
    MailIcon: () => import('@/../public/mail-icon.svg'),
  },
  methods: {
    nextStep (step) {
      if (step === steps.SELECT_LOGIN_TYPE) {
        if (this.$refs.email.validate()) {
          this.step = steps.SELECT_LOGIN_TYPE
          requestAnimationFrame(() => {
            this.$refs.loginWithPassword.$el.focus()
          })
        }
      } else {
        this.step = step
      }
    },
    signIn () {
      if (this.$refs.password.validate()) {
        this.loginError = false
        const { email, password } = this.credentials
        this.$store.dispatch('auth/signIn', { email, password })
          .catch(() => {
            this.loginError = true
          })
      }
    },
    sendAccessLink () {
      this.show = false
      this.loadingLink = true
      const nextUrl = this.$route.query['next-url']
      this.$store.dispatch('auth/sendAccessMail', { email: this.credentials.email, nextUrl }).then(() => {
        this.loadingLink = false
        this.step = steps.CHECK_YOUR_EMAIL
      })
    },
    back () {
      delete this.$route.query['next-url']
      this.$router.go(-1)
    },
    reset () {
      this.credentials.email = null
      this.credentials.password = null
      this.step = 1
    },
  },
  mixins: [routingMixins],
}
</script>

<style scoped lang="scss">
.v-card {
  margin: 10px;
}
.centered {
  width: auto;
}
.centered > div {
  margin: 0 auto;
}
.headline {
  width: 100%;
}
.login-title {
  font-weight: 600;
  font-size: 27px;
  line-height: 1.2;
  margin: auto;
}
.explanatory-text {
  font-size: 14px !important;
}
.text-login {
  font-weight: 200;
  margin: auto;
}
.login-logo {
  height: 4.5em !important;
  max-width: 300px;
}
.login-panel {
  border-radius: 10px;
  padding: 25px;
  flex: 1;
}
.email-text {
  opacity: 0.75;
}
.fixed-width {
  max-width: 550px !important;
}
.v-btn {
  background: rgba(255, 255, 255, 0.234);
}
.invert-color {
  filter: invert(100%);
}
.no-background {
  background: none !important;
}
</style>
